import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { TranslationOptionModel } from './models/translation-options-model';
import { TranslationOptionModelImpl } from './models/impls/translation-options-model';
import { TranslationSettingModel } from './models/translation-settings-model';
import { TranslationSettingModelImpl } from './models/impls/translation-settings-model';
import { AITranslationOptionsService } from './services/ai-translation-options-service';
import { AITranslationOptionsServiceImpl } from './services/impls/ai-translation-options-service';
import { OriginalOptionsService } from './services/original-options-service';
import { OriginalOptionsServiceImpl } from './services/impls/original-options-service';
import { TranslationOptionsService } from './services/translation-options-service';
import { TranslationOptionsServiceImpl } from './services/impls/translation-options-service';
import { TranslationSettingsService } from './services/translation-settings-service';
import { TranslationSettingsServiceImpl } from './services/impls/translation-settings-service';
import { SettingType } from './enums';

export const translationModule = (bind: interfaces.Bind) => {
    bind(TranslationOptionModel).to(TranslationOptionModelImpl);
    bind(AITranslationOptionsService).to(AITranslationOptionsServiceImpl);
    bind(OriginalOptionsService).to(OriginalOptionsServiceImpl);
    bind(TranslationOptionsService).to(TranslationOptionsServiceImpl);
    bind(TranslationSettingModel).to(TranslationSettingModelImpl).whenTargetNamed(SettingType.CURRENT);
    bind(TranslationSettingModel).to(TranslationSettingModelImpl).whenTargetNamed(SettingType.EXPECTED);
    bind(TranslationSettingsService)
        .toDynamicValue(context => {
            const model = context.container.getNamed<TranslationSettingModel>(TranslationSettingModel, SettingType.CURRENT);
            return new TranslationSettingsServiceImpl(model);
        })
        .whenTargetNamed(SettingType.CURRENT);
    bind(TranslationSettingsService)
        .toDynamicValue(context => {
            const model = context.container.getNamed<TranslationSettingModel>(TranslationSettingModel, SettingType.EXPECTED);
            return new TranslationSettingsServiceImpl(model);
        })
        .whenTargetNamed(SettingType.EXPECTED);
};
